import React from 'react';
import { Link } from '@prezi/bento';
import * as CommonDesign from '@prezi/common-design';
import { glassboxPreziAmp, glassboxWebJs } from '@prezi/client-logger-module';
import { Dumb as Atoms } from '../../atoms';
import { createDataLookup } from '../../const';
import { localI18n } from '../../../i18n';
import { isActive } from '../../../featureswitches/Features';
const uxCopy = {
  copyButton: localI18n._("Copy link"),
  copied: localI18n._("Copied")
};
const ViewLinkCopy = ({
  viewLink,
  handleCopyToClipboard,
  isSingleLineLink,
  documentId
}) => {
  const [copied, setCopied] = React.useState(false);
  const referralLinkSource = window.location.pathname.includes('dashboard/next') ? 'COLAB_DASHBOARD' : 'COLAB_EDITOR';
  const linkProps = {
    href: viewLink,
    target: '_blank',
    'data-lookup': createDataLookup('clickable-view-link')
  };
  return React.createElement(Atoms.ColumnAutoMin, null, isSingleLineLink ? React.createElement(Atoms.SingleLineLink, linkProps, viewLink) : React.createElement(Atoms.Link, linkProps, viewLink), React.createElement(Atoms.Button, {
    variant: "primary",
    onClick: () => {
      handleCopyToClipboard(viewLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      if (isActive('js-new-amp-dashboard') && documentId) {
        glassboxPreziAmp.logCopyLink({
          link: viewLink,
          document_id: documentId
        });
      } else {
        glassboxWebJs.logCopyReferralInviteLink({
          referral_link_source: referralLinkSource
        });
      }
    },
    "data-lookup": createDataLookup('copy-view-link-button')
  }, isActive('js-header-both-new-buttons') ? React.createElement(CommonDesign.IconSmallLink, null) : React.createElement(CommonDesign.IconSmallCopyLegacy, null), React.createElement("span", null, copied ? uxCopy.copied : uxCopy.copyButton)));
};
export const ViewLinkCopySecondary = ({
  viewLink,
  handleCopyToClipboard
}) => React.createElement(Atoms.ColumnAutoMin, null, React.createElement(Link, {
  href: viewLink,
  target: "_blank",
  "data-lookup": createDataLookup('clickable-view-link')
}, viewLink), React.createElement(Atoms.TertiaryButton, {
  variant: "primary",
  onClick: () => handleCopyToClipboard(viewLink),
  "data-lookup": createDataLookup('copy-view-link-button')
}, React.createElement(CommonDesign.IconSmallCopyLegacy, null), React.createElement("span", null, uxCopy.copyButton)));
export default ViewLinkCopy;